import { useQuery } from '@tanstack/react-query'
import { billingApi } from '../../utils/api'

/**
 * アップグレードの日割り差額の試算（BillingPage の確認ダイアログ）。
 * queryKey: ['upgrade-preview', planType]
 *
 * planType が null（ダイアログを開いていない / ダウングレードの確認）のときは実行しない。
 * 試算は表示のための値であり失敗しても操作は続けられるため、リトライはしない
 * （確認ダイアログを開いたまま待たせるより、金額を伏せて先へ進める方がよい）。
 */
export function useUpgradePreview(planType: string | null) {
  return useQuery({
    queryKey: ['upgrade-preview', planType],
    queryFn: () => billingApi.getUpgradePreview(planType as string),
    enabled: planType !== null,
    retry: false,
    // 金額は時間経過で変わる（日割りの残り期間が縮む）。開くたびに取り直す。
    staleTime: 0,
    gcTime: 0,
  })
}
